import { useState } from 'react'

import { Box, SelectOption } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import SingleChoiceFilter from 'modules/core/components/Filter/filters/SingleChoice'
import useAsyncAction from 'modules/core/hooks/useAsyncAction'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import type { NotifierPreferences } from 'modules/notifications/components/Preferences/PreferencesList/hooks/useComputedPreferences'

interface Props {
  notifier: NotifierPreferences
  onScopeUpdated: (notifier: string, newValue: string) => Promise<void>
}

const Scopes = ({ notifier, onScopeUpdated }: Props) => {
  const MIN_OPTIONS_TO_SHOW_SCOPE_SELECTOR = 2

  const [chosenValue, setChosenValue] = useState(notifier.currentScope)
  const { performAction } = useAsyncAction(async (newValue: string) => {
    if (newValue !== chosenValue) {
      // For a more responsive UX
      setChosenValue(newValue)

      await onScopeUpdated(notifier.identifier, newValue)

      track(trackingEvents.inbox.preferences.updateScope, {
        changed_to: newValue,
        notifier: notifier.identifier,
      })
    }
  })

  useEffect(() => {
    setChosenValue(notifier.currentScope)
  }, [notifier.currentScope])

  if (!notifier.availableScopes) {
    return null
  }

  const options: SelectOption[] = Object.entries(notifier.availableScopes).map(
    ([value, label]) => ({
      value,
      label,
    })
  )

  return (
    <Box width="fit-content">
      {options.length >= MIN_OPTIONS_TO_SHOW_SCOPE_SELECTOR && (
        <Box paddingTop="s8">
          <SingleChoiceFilter
            label={i18n.t('notifications.selectors.scopes.label')}
            options={options}
            onValueChange={(item) => performAction(String(item))}
            value={chosenValue}
            footer={<></>}
          />
        </Box>
      )}
    </Box>
  )
}

export const ScopeSelector = observer(({ notifier, onScopeUpdated }: Props) => {
  return (
    <>
      <Scopes notifier={notifier} onScopeUpdated={onScopeUpdated} />
    </>
  )
})
